"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const stimulus_1 = require("@hotwired/stimulus");
class default_1 extends stimulus_1.Controller {
    rate(event) {
        if (event && event.target) {
            const element = event.target.closest('span');
            if (element) {
                const rating = element.dataset.starsRating;
                if (rating) {
                    this.starRatingTarget.value = rating;
                    const stars = this.starContainerTarget.querySelectorAll('.star');
                    stars.forEach(function (value) {
                        if (value && value.dataset && value.dataset.starsRating) {
                            const svg = value.querySelector('svg');
                            console.log(svg);
                            if (svg) {
                                if (rating >= value.dataset.starsRating) {
                                    console.log('flip');
                                    svg.classList.add('text-yellow-400');
                                    svg.classList.remove('text-gray-300');
                                }
                                else {
                                    console.log('clip');
                                    svg.classList.remove('text-yellow-400');
                                    svg.classList.add('text-gray-300');
                                }
                            }
                        }
                    });
                }
            }
        }
    }
}
exports.default = default_1;
default_1.targets = ["starContainer", "starRating"];
